module.exports = __webpack_public_path__ + "static/img/success16.b37a03b7.png";